<template>
  <ul class="nav nav-tabs mb-5">
    <li class="nav-item">
      <router-link
          class="nav-link cursor-pointer"
          :class="{ active: $route.name === 'unemployedNewAndActiveList' }"
          :to="{ name: 'unemployedNewAndActiveList' }">
        Kunden
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
          class="nav-link cursor-pointer"
          :class="{ active: $route.name === 'unemployedPotentialList' }"
          :to="{ name: 'unemployedPotentialList' }">
        Interessenten
      </router-link>
    </li>
  </ul>

  <ul class="nav nav-tabs mb-5 sm d-flex justify-content-end">
    <li class="nav-item">
      <router-link
          class="nav-link cursor-pointer"
          :class="{ active: $route.name === 'unemployedNewAndActiveList' }"
          :to="{ name: 'unemployedNewAndActiveList'}">
        Aktive + Neu
      </router-link>
    </li>
    <li class="nav-item">
      <router-link
          class="nav-link cursor-pointer"
          :class="{ active: $route.name === 'unemployedFinishedList' }"
          :to="{ name: 'unemployedFinishedList' }">
        Abgeschlossen
      </router-link>
    </li>
  </ul>
</template>

<script setup></script>
